<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="名称"
          prop="userName"
        >
          <el-input
            v-model="searchForm.userName"
            placeholder="名称"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item
                label="用户名"
                prop="userCode"
        >
          <el-input
                  v-model="searchForm.userCode"
                  placeholder="用户名"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="手机号码"
                prop="mobileno"
        >
          <el-input
                  v-model="searchForm.mobileno"
                  placeholder="手机号码"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="公司"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
        label="法人姓名"
        prop="legal"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
        label="手机号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
        <el-table-column
                label="贡献值"
                prop="red_amt"
                sortable="custom"
                :show-overflow-tooltip="true"
        >
            <template slot-scope="scope">
                {{scope.row.red_amt}}
            </template>
        </el-table-column>
      <el-table-column
              label="补贴金"
              prop="vch_amt"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.vch_amt}}
        </template>
      </el-table-column>
      <el-table-column
        label="用户名"
        prop="userCode"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="合作期限"
              prop="userCode"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.contractstdate}}/{{scope.row.contractendate}}
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.pass=='0'">
           已签约
          </div>
          <div v-else-if="scope.row.pass=='1'">
            未签约
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="400"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">详情</el-button>

          <el-button type="primary" plain size="mini"    @click="reset(scope.row.userId)">重置密码</el-button>
          <el-button type="primary" plain size="mini"  v-if="is_dl_type=='-1' || is_agentid=='7080007'"   @click="openUpgradeForm(scope.row)">升级</el-button>
          <el-button type="primary" plain size="mini"  v-if="is_dl_type=='-1' || is_agentid=='7080007'"   @click="openViewForm(scope.row)">修改上级</el-button>
          <el-button type="primary" plain size="mini"  v-if="is_dl_type=='-1' || is_agentid=='7080007'"   @click="openSfzForm(scope.row)">查看身份信息</el-button>

        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneagent="oneagent"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <view-form
            :oneagent="oneagent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />
    <gxz-form
            :oneagent="oneagent"
            v-model="gxzFormVisible"
            @submit="getTableData"
    />
    <glj-form
            :oneagent="oneagent"
            v-model="gljFormVisible"
            @submit="getTableData"
    />
    <upgrade-form
            :oneagent="oneagent"
            v-model="upgradeFormVisible"
            @submit="getTableData"
    />

    <sfz-form
            :oneagent="oneagent"
            v-model="sfzFormVisible"
            @submit="getTableData"
    />
  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import viewForm from "./viewForm";
import sfzForm from "./sfzForm";
import upgradeForm from "./upgradeForm";
import gxzForm from "@/pages/sys/twoagenty/gxzForm";
import gljForm from "@/pages/sys/twoagenty/gljForm";
import util from '@/libs/util.js'
export default {
  name: "TwoagentyPage",
  components: { editForm,viewForm,upgradeForm,sfzForm,gxzForm,gljForm},
  data() {
    return {
      searchForm: {
          userName: "",
          userCode: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        is_agentid:util.cookies.get('agentid'),
        is_dl_type:util.cookies.get('dl_type'),
        is_sys_kf:util.cookies.get('is_sys_kf'),
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneagent: {},
      editFormVisible: false,
        viewFormVisible: false,
        sfzFormVisible: false,
        gxzFormVisible: false,
      gljFormVisible: false,
        upgradeFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          dl_type: util.cookies.get('dl_type'),
          dl_type2:'2',
          state_type:'0',
          xt_id:util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneagent) {
      this.oneagent = oneagent;
      this.editFormVisible = true;
        this.viewFormVisible = false;
        this.upgradeFormVisible = false;
    },
      openViewForm(oneagent) {
          this.oneagent = oneagent;
          this.editFormVisible = false;
          this.viewFormVisible = true;
          this.upgradeFormVisible = false;
      },

      openGxzForm(oneagent) {
          this.oneagent = oneagent;
          this.editFormVisible = false;
          this.viewFormVisible = false;
          this.upgradeFormVisible = false;
          this.gxzFormVisible=true;
      },
    openGljForm(oneagent) {
      this.oneagent = oneagent;
      this.editFormVisible = false;
      this.gljFormVisible=true;
    },
      openSfzForm(oneagent) {
          this.oneagent = oneagent;
          this.editFormVisible = false;
          this.viewFormVisible = false;
          this.sfzFormVisible = true;
          this.upgradeFormVisible = false;
      },
      openUpgradeForm(oneagent) {
          this.oneagent = oneagent;
          this.editFormVisible = false;
          this.viewFormVisible = false;
          this.upgradeFormVisible = true;
      },
      reset(userId) {
        let msg = "重置密码";
      this.$confirm("确定要重置该帐号的密码吗？！重置后的密码为123456", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          agentService.resetAgent({userId:userId}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
